import DoughnutChart from './doughnut-chart';

export {
  DoughnutChart
};



// WEBPACK FOOTER //
// ./src/browser/components/ui/charts/index.js